import * as React from 'react';

import { Space } from 'v2/components/Shared/Space';

import { Footer } from '../Layout/Footer';
import { Header } from '../Layout/Header';

function Final() {
  return (
    <>
      <Header
        title='Falta pouco!'
        description='Estamos validando os dados enviados e se tudo estiver certinho você poderá fazer as transferências dos seus ganhos. Te avisaremos por e-mail, mas você também pode acompanhar a validação da sua conta no menu Dados Bancários ou clicando no link abaixo.'
      />
      <Space axis='vertical' size={40} />
      <Footer />
    </>
  );
}

export { Final };
